<template>
  <v-row justify="center">
    <!-- don't use v-model because it will try to edit dialog which is a prop -->
    <v-dialog :value="dialog" @input="close" max-width="600px">
      <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
        <v-card :loading="loading_dialog" v-if="item != null">
          <v-card-title>
            <span class="headline">{{ item.category }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider name="type" rules="required"  v-slot="{ errors, valid }">
                      <v-text-field
                        v-model="item.type"
                        label="Type"
                        :error-messages="errors"
                        :success="valid"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="brand" rules="required"  v-slot="{ errors, valid }">
                      <v-text-field
                        v-model="item.brand"
                        label="Brand"
                        :error-messages="errors"
                        :success="valid"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="notes" rules="required"  v-slot="{ errors, valid }">
                      <v-text-field
                        v-model="item.notes"
                        label="Notes"
                        :error-messages="errors"
                        :success="valid"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="selectItems"
                      v-model="selectValue"
                      label="Available"></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            <v-btn color="blue darken-1" text @click="saveInfo" :disabled="invalid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'

export default {
  props: {
    dialog: Boolean,
    loading_dialog: Boolean,
    item: Object
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      selectItems: ['---','Yes','No'],
      selectValue: null
    }
  },
  computed: {
    selectValueFormatted() {
      const value = this.item.b_cme_supplier_has_available
      if(value == 1) { return 'Yes' }
      else if(value == 0) { return 'No' }
      else { return '---' }
    }
  },
  methods: {
    close() {
      this.$emit('closedialog')
    },
    saveInfo() {
      if(this.selectValue == 'Yes') { this.item.b_cme_supplier_has_available = 1 }
      else if(this.selectValue == 'No') { this.item.b_cme_supplier_has_available = 0 }
      else { this.item.b_cme_supplier_has_available = 2 }
      this.$emit('saveinfo', this.item)
    }
  },
  updated() {
    this.selectValue = this.selectValueFormatted
  }
}
</script>